import { fetchData, apiURL } from "./api_helper";

//  USER CRUD

//  CREATE
const createBox = data =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/boxes`;
    fetchData(endpointURL, "post", data)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });

const generateBoxes = data =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/boxes/generate`;
    fetchData(endpointURL, "post", data)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });

//  READ
const readBoxByQR = data =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/boxes/boxByQr/${data.id}`;
    fetchData(endpointURL, "get")
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });

const readBoxesByQR = data =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/boxes/boxByQr`;
    fetchData(endpointURL, "post", { boxQRs: data })
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });

const readBox = data =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/boxes/${data.id}`;
    fetchData(endpointURL, "get")
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });

const readBoxes = data =>
  new Promise((resolve, reject) => {
    const body = {
      ...data.filter
    };
    if (data.page) {
      body["page"] = data.page;
    }
    const endpointURL = `${apiURL}/boxes`;
    fetchData(endpointURL, "get", body)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });

const readBoxesByPartner = data =>
  new Promise((resolve, reject) => {
    const body = {};
    if (data.partnerID) {
      body["partnerID"] = data.partnerID;
    }
    if (data.page) {
      body["page"] = data.page;
    }

    const endpointURL = `${apiURL}/boxes/byPartners`;
    fetchData(endpointURL, "get", body)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });

const readBoxInfo = data =>
  new Promise((resolve, reject) => {
    const body = {
      ...data.filter
    };
    const endpointURL = `${apiURL}/boxes/boxInfo`;
    fetchData(endpointURL, "get", body)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });

const readNextQrNumber = () =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/boxes/nextQrNumber`;
    fetchData(endpointURL, "get")
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });

//  UPDATE
const updateBox = data =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/boxes/${data.id}`;
    fetchData(endpointURL, "PATCH", data.body)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });

const changeQRNumber = data =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/boxes/${data.id}`;
    fetchData(endpointURL, "PATCH")
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });

//  DELETE
const deleteBox = data =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/boxes/${data.id}`;
    fetchData(endpointURL, "delete")
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });

export default {
  createBox,
  generateBoxes,
  readBox,
  readBoxByQR,
  readBoxesByQR,
  readBoxes,
  readBoxesByPartner,
  readBoxInfo,
  readNextQrNumber,
  updateBox,
  changeQRNumber,
  deleteBox
};
